import React, { useState, useEffect } from 'react'
import { YhOfferPrint } from "../OfferPrint/OfferPrint"
import { purchaseRoService } from './purchaseRoService';
import { IDetailList, IPurchaseRoFields } from './purchaseRoType';
import { numberParseChina, momentFormat } from '@/utils/utils';
import { fmoney } from "../../utils";
import { useDictModel } from '@/views/base/dict/dictModel';
import moment from 'moment';
import useGlobalModel from '@/model/globalModel';
import { usePrintModel } from "@/views/receipt/outWarehouse/view/printModel";

export type IMaintenanceAndItemType = {
    total: number
    discount: number
}
export type TotalType = {
    num: number,
    total: number
}
export function BcmPurcharseReturnPrint() {
    const initDesc = { total: 0, discount: 0 }
    const totalDesc = { total: 0, num: 0 }
    const { CustomerData, user: { shopName, shopId, shopCode } } = useGlobalModel()
    const [settlementPartyName, setSettlementPartyName] = useState<string>("")
    const [formVal, setFormVal] = useState<IPurchaseRoFields>({});
    const [maintenanceList, setMaintenanceList] = useState<IDetailList[]>([]);
    const [maintenanceTotal, setMaintenanceTotal] = useState<IMaintenanceAndItemType>(initDesc);
    const [itemTotal, setItemTotal] = useState<IMaintenanceAndItemType>(initDesc);
    const [total, setTotal] = useState<TotalType>(totalDesc);
    const { getTreeNodeName, getTreeNodeOne } = useDictModel();
    const { code, bcmPurcharseReturnPV, setBcmPurcharseReturnPV } = usePrintModel()

    // const { shopAndOrg: { shopCode } } = useGlobalModel()
    useEffect(() => {
        bcmPurcharseReturnPV && getPoDetailOne()
    }, [bcmPurcharseReturnPV])
    //获取一条数据
    const getPoDetailOne = async () => {
        let { retData } = await purchaseRoService.one(code);
        let { details, ...formVal } = retData;

        let newMaintenanceTotal = { ...maintenanceTotal }
        let newItemTotal = { ...itemTotal }
        let newTotal = { ...total }


        let newdetails: any = details?.map((item, index) => {
            newMaintenanceTotal.total += Number(item.num) * Number(item.price)
            newTotal.num += Number(item.num)
            let { amount } = item

            return {
                ...item,
                No: index + 1,
                notAmount: Number(item.num) * Number(item.price),
                amount: fmoney(amount, 2)
            }
        })

        // if (settlementPartyCode === "settle-party.internal") {
        //     setSettlementPartyName(shopName)
        // } else if (settlementPartyCode && (settlementPartyCode?.indexOf("man") !== -1 || settlementPartyCode?.indexOf("scn") !== -1)) {
        //     let { value: customerCode } = getTreeNodeOne(settlementPartyCode as string)[0]
        //     // console.log(settlementPartyCode, getTreeNodeOne(settlementPartyCode as string),getFindItem(customerCode, CustomerData))
        //     setSettlementPartyName(getFindItem(customerCode, CustomerData).name)
        // }
        //这里做最后一行汇总信息展示
        // newdetails?.push({
        //     num: newTotal.num,
        //     No: "",
        //     materialCode: "合计",
        //     amount: fmoney(formVal.totalAmount, 2)
        // })
        if (retData) {
            setMaintenanceList(newdetails as IPurchaseRoFields[] ?? []);
            // setFormVal(formVal)
            setFormVal({ ...formVal })
            setMaintenanceTotal(newMaintenanceTotal)
            setItemTotal(newItemTotal)
        }
    };

    const onCancel = () => {
        setBcmPurcharseReturnPV(false)
        setMaintenanceList([]);
        setFormVal({})
        setMaintenanceTotal(initDesc)
        setItemTotal(initDesc)
    }
    const columns = [
        {
            title: '序号',
            dataIndex: 'No',
        },
        {
            title: '商品编号',
            dataIndex: 'materialCode',
        },
        {
            title: '商品名称',
            dataIndex: 'materialName',
        },
        {
            title: '单位',
            dataIndex: 'unitName',
        },
        {
            title: '数量',
            dataIndex: 'num',
        },
        {
            title: '单价',
            dataIndex: 'price',
        },
        // {
        //     title: '折扣',
        //     dataIndex: 'discountRate',
        //     render: (text: any) => text + "%"
        // },
        // {
        //     // title: '折后单价 Discounted Price',
        //     title: '单价 Unit price',
        //     dataIndex: 'taxPrice',
        // },
        {
            title: '金额',
            dataIndex: 'amount',
        },
        {
            title: '货位',
            dataIndex: 'shelfCode',
        },
    ]
    //头部与底部展示
    const printShow = {
        header: [
            {
                fieldLabel: "采退单号：",
                fieldValue: formVal?.returnCode,
                className: "w30"
            },
            {
                fieldLabel: "供应商名称：",
                fieldValue: formVal?.supplierName,
            },
            {
                fieldLabel: "",
                fieldValue: "",
                className: "w20"

            },
            {
                fieldLabel: moment(new Date()).format("YYYY-MM-DD HH:mm"),
                fieldValue: "",
                className: "li-right"
            },
            {
                fieldLabel: "联系人：",
                fieldValue: formVal?.contact
            },
            {
                fieldLabel: "电话：",
                fieldValue: formVal?.phone
            },
            {
                fieldLabel: "单据性质：",
                fieldValue: "采退单"
            },
            {
                fieldLabel: "采退日期：",
                fieldValue: momentFormat(formVal?.createTime as string),
                className: "li-right"
            },
        ],
        footerPeople: [
            {
                fieldLabel: "制表人：",
                fieldValue: formVal?.createUser
            },
            {
                fieldLabel: "采购：",
                fieldValue: ""
            },
            {
                fieldLabel: "出纳：",
                fieldValue: ""
            },
            {
                fieldLabel: "仓库：",
                fieldValue: maintenanceList[0]?.warehouseName
            },
            {
                fieldLabel: "会计：",
                fieldValue: ""
            },
            // {
            //     fieldLabel: "客户：",
            //     fieldValue: formVal?.customerName
            // },

        ],
        note: {
            fieldLabel: "备注:",
            fieldValue: formVal?.note
        },
        Total: {
            numAll: maintenanceList.length,
            receivedAmountChina: numberParseChina(formVal?.payableAmount as number),
            receivedAmount: formVal?.payableAmount
        },
        // Total: [
        //     {
        //         fieldLabel: "大写金额 THE SUM OF：",
        //         fieldValue: numberParseChina(formVal?.receivedAmount as string)
        //     },
        //     {
        //         fieldLabel: "结算类型 Payment Type：",
        //         fieldValue: getTreeNodeName(formVal?.payType as string)
        //     },
        // ],
    }
    const headerTitle = {
        // title: "天津欧豪富港汽车贸易有限公司销售退货单"
        title: `${formVal.bentityName as string}采退单`

    }
    return (
        <YhOfferPrint
            title="采退单单打印详情"
            type=""
            visible={bcmPurcharseReturnPV}
            onClose={onCancel}
            columns={columns}
            dataSource={maintenanceList.filter(item => item.num !== 0)}
            printShow={printShow}
            headerTitle={headerTitle}
        />
    )
}